export class SupplierContactFormModel {
  public companyName: string | null = null;
  public representativeFirstName: string | null = null;
  public representativeLastName: string | null = null;
  public phoneNumber: string | null = null;
  public mobileNumber: string | null = null;
  public emailAddress: string | null = null;
  public street: string | null = null;
  public postalCode: string | null = null;
  public city: string | null = null;
  public country: string | null = null;
  public website: string | null = null;
  public coverADR: boolean = false;
  public co2Score: number | null = null;
  public co2EmissionTotal: number | null = null;
  public scorePlatform: string | null = null;
  public scorePlatformLink: string | null = null;

  constructor(init?: Partial<SupplierContactFormModel>) {
    Object.assign(this, init);
  }
}

export function IsSupplierContactFormEmpty(data: SupplierContactFormModel): boolean {
  return (
    data.companyName === null ||
    data.representativeFirstName === null ||
    data.representativeLastName === null ||
    data.phoneNumber === null ||
    data.mobileNumber === null ||
    data.emailAddress === null ||
    data.street === null ||
    data.city === null ||
    data.postalCode === null ||
    data.country === null ||
    data.coverADR === null ||
    data.co2Score === null ||
    data.co2EmissionTotal === null ||
    data.scorePlatform === null ||
    data.scorePlatformLink === null
  );
}

export function IsSupplierContactFormValid(data: SupplierContactFormModel): boolean {
  if (IsSupplierContactFormEmpty(data)) {
    return false;
  }
  return (
    data.companyName!.length > 0 &&
    data.representativeFirstName!.length > 0 &&
    data.representativeLastName!.length > 0 &&
    data.phoneNumber!.length > 0 &&
    data.emailAddress!.length > 0 &&
    data.street!.length > 0 &&
    data.city!.length > 0 &&
    data.postalCode!.length > 0 &&
    data.country!.length > 0 &&
    data.scorePlatform!.length > 0 &&
    data.scorePlatformLink!.length > 0
  );
}
